import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "./App.scss";
import Main from "./pages/Main"
import Search from "./pages/Search"
import Location from "./pages/Location"
import LocationAdd from "./pages/LocationAdd"
import LocationResults from "./pages/LocationResults"
import Equipment from "./pages/Equipment"
import ProductsResults from "./pages/ProductsResults"
import AllSpaceResults from "./pages/AllSpaceResults";
import BuildingResults from "./pages/BuildingResults";
import Building from "./pages/Building";
import BuildingAdd from "./pages/BuildingAdd";
import Space from "./pages/Space";
import SpaceAdd from "./pages/SpaceAdd";
import Zone from "./pages/Zone";
import ZoneAdd from "./pages/ZoneAdd";
import EquipmentResults from "./pages/EquipmentResults";
import EquipmentAdd from "./pages/EquipmentAdd";
import VariableResults from "./pages/VariableResults";
import VariableAdd from "./pages/VariableAdd";
import FeaturesAdd from "./pages/FeaturesAdd";
import Advanced from "./pages/Advanced";
import ScheduleModule from "./pages/ScheduleModule"
import { ConfirmSignIn, ForgotPassword, RequireNewPassword, SignIn, withAuthenticator, AmplifyTheme } from 'aws-amplify-react';
import { ConfirmProvider } from 'material-ui-confirm';

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import { Header } from "./components/LoginComponents/Header";

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';

const MySectionHeaderText = Object.assign({}, AmplifyTheme.sectionHeaderText, { 'fontSize': 20 });
const containerDefault = Object.assign({}, AmplifyTheme.container, { 'fontFamily': 'Lato'});
const formContainer = Object.assign({}, AmplifyTheme.formContainer, { 'margin': 0});
const MyTheme = Object.assign({}, AmplifyTheme, { sectionHeader: MySectionHeaderText, container: containerDefault });


Amplify.configure(awsconfig);


const App = ({ signOut, user}) => {

      return (
		  <div>
			  <ConfirmProvider>
				<MuiPickersUtilsProvider utils={LuxonUtils}>
					<Switch>
						<Route path="/" exact><Redirect to="/main"/></Route>
						<Route path="*">
						<div className="main-body">
						<Switch>
						<Route path="/main"><Main/></Route>
						<Route path="/search"><Search/></Route>
						<Route path="/locations/add" exact={true}><LocationAdd  school={true} /></Route>
						<Route path="/locations" exact={true}><LocationResults /></Route>
						<Route path="/locations/:location" exact={true}><Location /></Route>
						<Route path="/locations/:location/equipment"><EquipmentResults /></Route>
						<Route path="/locations/:location/advanced"><Advanced /></Route>
						<Route path="/buildings" exact={true} ><BuildingResults /></Route>
						<Route path="/buildings/add" exact={true}><BuildingAdd /></Route>
						<Route path="/buildings/:buildingId"><Building /></Route>
						<Route path="/spaces" exact={true} ><AllSpaceResults /></Route>
						<Route path="/spaces/add" exact={true} ><SpaceAdd /></Route>
						<Route path="/spaces/:spaceId" exact={true} ><Space /></Route>
						<Route path="/zones/add" exact={true} ><ZoneAdd /></Route>
						<Route path="/zones/:zoneId" exact={true} ><Zone /></Route>
						<Route path="/equipment" exact={true}><EquipmentResults /></Route>
						<Route path="/equipment/add" exact={true}><EquipmentAdd /></Route>

						{/* Extra processing used for related equipment where one equipment page links to the next.  Needs to be forced to re-render */}
						<Route path="/equipment/:equipmentId" exact={true} render={props => <Equipment key={props.match.params.equipmentId} {...props} />} />
						
						<Route path="/variables/:context/:id/add" exact={true}><VariableAdd /></Route>
						<Route path="/variables/:context/:id"><VariableResults /></Route>
						<Route path="/features/add" exact={true}><FeaturesAdd /></Route>
						<Route path="/schedules" exact={true}><ScheduleModule /></Route>
						<Route path="/products" exact={true}><ProductsResults /></Route>
						<Route path="*"><div>404</div></Route> { /* add later */ }
					</Switch>
					</div>
					</Route>
				</Switch>
				</MuiPickersUtilsProvider>
			</ConfirmProvider>
		  </div>
    )

}

export default withAuthenticator(App, true, [
	<Header />,
	<SignIn />,
	<RequireNewPassword />,
	<ForgotPassword />,
	<ConfirmSignIn />,
], false, MyTheme, {isSignUpDisplayed: false});
